import { type ReactNode, type Ref } from 'react'
import {
	type LabelProps as AriaLabelProps,
	Label as AriaLabel,
} from 'react-aria-components'
import { cx } from '#app/utils/cx'

interface LabelProps extends AriaLabelProps {
	children: ReactNode
	isRequired?: boolean
	ref?: Ref<HTMLLabelElement>
}

export const Label = ({ isRequired, className, ...props }: LabelProps) => {
	return (
		<AriaLabel
			// Used for conditionally hiding/showing the label element via CSS:
			// <Input label="Visible only on mobile" className="lg:**:data-label:hidden" />
			// or
			// <Input label="Visible only on mobile" className="lg:label:hidden" />
			data-label="true"
			{...props}
			className={cx(
				'text-secondary flex w-full cursor-default items-center gap-0.5 text-sm font-medium',
				className,
			)}
		>
			{props.children}

			<span
				className={cx(
					'text-brand-tertiary hidden',
					isRequired && 'block',
					typeof isRequired === 'undefined' && 'group-required:block',
				)}
			>
				*
			</span>
		</AriaLabel>
	)
}

Label.displayName = 'Label'
